module.exports = __webpack_public_path__ + "static/img/2-2.3fdd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/2-2.png
// module id = LoNC
// module chunks = 0